module.exports = __webpack_public_path__ + "img/Python.2d2000ae.png";